/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGridPattern = createReactComponent("outline", "grid-pattern", "IconGridPattern", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }], ["path", { "d": "M8 10h8", "key": "svg-3" }], ["path", { "d": "M8 14h8", "key": "svg-4" }]]);

export { IconGridPattern as default };
//# sourceMappingURL=IconGridPattern.mjs.map
